import { LoadState } from "../../constants/enums";
import { IAgentToolsState } from "./AgentTools.types";

export const initialAgentToolsState: IAgentToolsState = {
  registry: {
    data: [],
    loading: LoadState.NotLoaded,
    error: null,
  },
  mappings: {
    data: [],
    loading: LoadState.NotLoaded,
    error: null,
  },
};
